import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

export function getRankingMensualApi(clienteId, mes) {
  return axios.get(`${API_PATH}/kpi/ranking-mensual`, {
    params: { cliente_id: clienteId, mes },
    headers: { Authorization: getAccessTokenApi() },
  });
}

export function getPrimerMesClienteApi(clienteId) {
  return axios.get(`${API_PATH}/kpi/primer-mes-cliente`, {
    params: { cliente_id: clienteId },
    headers: { Authorization: getAccessTokenApi() },
  });
}
